import { render, staticRenderFns } from "./VideoAds.vue?vue&type=template&id=6c3dfc34&"
import script from "./VideoAds.vue?vue&type=script&lang=ts&"
export * from "./VideoAds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports